import { z } from 'zod/v4';

/**
 * Response body for `POST /integrations/amfori/credentials/test`.
 *
 * Returned ONLY on a successful credential verification: an Amfori SSO mint
 * call returned `200 OK` AND the resulting JWT carried the
 * `company_amfori_id` claim.
 *
 * NOTE: `memberAmforiId` is non-null here even though it is nullable on
 * `AmforiCredentialsResourceSchema` — verification cannot succeed without a
 * decoded claim, so the field is always present in this response.
 *
 * Failure modes are propagated as domain errors (`InvalidCredentialsError`,
 * `AmforiAuthError`) and surfaced via the central HTTP error mapper, not via
 * an alternate response shape.
 */
export const AmforiTestConnectionResponseSchema = z
  .object({
    ok: z.literal(true),
    expiresIn: z.number().int().positive(),
    memberAmforiId: z.string(),
  })
  .strict();

export type AmforiTestConnectionResponse = z.infer<
  typeof AmforiTestConnectionResponseSchema
>;
